import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axiosInstance from "../axios/axios";
import uploadBtn from "../assets/uploadBtn.svg";
import Loader from "./Loader";

const ViewJob = () => {
  const { id } = useParams();
  const [jobs, setJobs] = useState([]); // State to store fetched jobs
  const [loading, setLoading] = useState(true); // Loading state

  const fetchViewJob = async () => {
    try {
      const response = await axiosInstance.get(`/view/jobs/${id}`);
      setJobs(response.data.job || []); // Ensure response is structured correctly
      localStorage.setItem("job_id", response.data.job.id);
      console.log(response.data.job, "data");
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false); // Stop loading once the fetch is complete
    }
  };

  useEffect(() => {
    fetchViewJob();
  }, [id]);

  if (loading) return <Loader />;

  if (!Array.isArray(jobs)) {
    // Handle case when jobs is a single object
    const userRole = localStorage.getItem("userRole");
    // Improved requirements formatting
    let formattedRequirements = [];
    if (jobs.job_requirements) {
      const lines = jobs.job_requirements
        .split("\n")
        .filter((line) => line.trim() !== "");
      lines.forEach((line) => {
        // Detect numbered, asterisk, or dash lines
        if (/^(\d+\.\s*|\*\s*|-)/.test(line.trim())) {
          formattedRequirements.push({
            type: "li",
            content: line.replace(/^(\d+\.\s*|\*\s*|-)/, "").trim(),
          });
        } else {
          formattedRequirements.push({
            type: "p",
            content: line.trim(),
          });
        }
      });
    }

    return (
      <div className="p-[24px]">
        <div className="flex flex-col justify-between items-center w-full top-bar">
          <div className="flex justify-between py-3 px-2 items-center w-full ">
            <span>Jobs</span>
            {userRole === "organization" ? (
              <Link
                to="/dashboard/create-job"
                className="hidden md:flex gap-2 items-center justify-center rounded-[8px] border-2 border-[#049645] py-[10px] px-[14px]"
              >
                <img src={uploadBtn} alt="Upload Button" />
                <span>Create Job</span>
              </Link>
            ) : null}
          </div>
        </div>
        <section className="md:mt-[40px] flex flex-col gap-6">
          <div className="flex w-full justify-between custom-section xsm:flex-col ">
            <div className="flex flex-col gap-4 ">
              <span className="label-name w-full">Company&apos;s Name</span>
              <span className="content-container">{jobs.company_name}</span>
            </div>
            <div className="flex flex-col gap-4 ">
              <span className="label-name">Company&apos;s Email Address</span>
              <span className="content-container">{jobs.company_email}</span>
            </div>
          </div>
          <div className="flex w-full justify-between custom-section xsm:flex-col ">
            <div className="flex flex-col gap-4 ">
              <span className="label-name w-full">Job Title</span>
              <span className="content-container">{jobs.job_title}</span>
            </div>
            <div className="flex flex-col gap-4 ">
              <span className="label-name w-full">Department</span>
              <span className="content-container">{jobs.department}</span>
            </div>
          </div>
          <div className="flex w-full justify-between custom-section xsm:flex-col ">
            <div className="flex flex-col gap-4 ">
              <span className="label-name">Stipend</span>
              <span className="content-container">
                {jobs.stipend === 1 ? "Paid" : "Unpaid"}
              </span>
            </div>
            <div className="flex flex-col gap-4 ">
              <span className="label-name">Work Environment</span>
              <span className="content-container">{jobs.env_mode}</span>
            </div>
            <div className="flex flex-col gap-4 ">
              <span className="label-name">Duration</span>
              <span className="content-container">{jobs.duration}</span>
            </div>
            <div className="flex flex-col gap-4 ">
              <span className="label-name">Application Deadline</span>
              <span className="content-container">{jobs.deadline}</span>
            </div>
          </div>
        </section>
        <section className="flex flex-col flex-wrap gap-3 mt-3">
          <p className="p">Job Description</p>
          <div className="flex border rounded-lg gap-[17px] p-[24px] flex-col">
            <p className="text-base leading-relaxed whitespace-pre-line">
              {jobs.job_description}
            </p>
          </div>
          <p className="">Role Overview and Requirements</p>
          <div className="flex border rounded-lg gap-[17px] p-[24px] flex-col">
            <ul className="space-y-2 text-base leading-relaxed list-disc pl-4">
              {formattedRequirements.map((item, index) =>
                item.type === "li" ? (
                  <li key={index}>{item.content}</li>
                ) : (
                  <p key={index} className="mb-2">
                    {item.content}
                  </p>
                )
              )}
            </ul>
          </div>
        </section>
        <Link
          to={
            jobs.org_id
              ? `/dashboard/jobs/${jobs.id}/apply/${jobs.org_id}`
              : "/job/unknown"
          }
          className="btn btn-success mt-3 w-full"
        >
          Apply
        </Link>
      </div>
    );
  }
};

export default ViewJob;